import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
    ITCIApplicationMonitoring,
    ITCIApplicationMonitoringProvider,
    ITCIApplicationsMonitoringRequest,
    ITCIMonitoringInstance,
    TCI_APP_MONITORING_REQUEST_TYPE,
    TCITenantSelectorType
} from "@tci/common";
import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../../../ng-app-details-menu";
import { AbstractTCITenantComponent } from "../../../../../ng-tenant/tci-tenant-component";
import { NgToastrService } from "../../../../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { BaseSubmenuMonitoringFlowsService } from "./base-submenu-flows.service";

import { Subscription } from "rxjs";

@Component({
    selector: TCITenantSelectorType.TCI_MENU_APP_MONITORING_FLOWS.toString(),
    templateUrl: "./base-submenu-flows.component.html",
    styleUrls: ["./base-submenu-flows.component.less"]
})
export class BaseSubmenuFlowsComponent<E, I extends BaseAppDetailMenuComponentInput, O extends BaseAppDetailMenuComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> implements OnInit, OnDestroy {
    private monSvc: ITCIApplicationMonitoringProvider;
    private subscriptions: Subscription[] = [];

    instanceSelected: ITCIMonitoringInstance;

    constructor(
        private resourceSvc: BaseSubmenuMonitoringFlowsService,
        protected translate: TranslateService,
        protected toastr: NgToastrService
    ) {
        super();
    }

    ngOnInit(): void {
        this.initInstanceSubs();

        this.resourceSvc.getMonitoringService(this.input.application.type)
            .subscribe(res => {
                this.monSvc = res;
                this.initInstanceSubs();
            }, err => {
                console.log(err);
            });
    }

    ngOnDestroy(): void {
    }

    private initInstanceSubs() {
        this.monSvc.getSelectedInstance()
            .subscribe(res => this.instanceSelected = res);

        this.subscriptions.push(
            this.monSvc.getAppMonitoringSubject(TCI_APP_MONITORING_REQUEST_TYPE.APP_INSTANCE_SELECTED)
                .map(res => (<ITCIApplicationMonitoring>res.result).selectedInstance)
                .subscribe(res => this.instanceSelected = res)
        );
    }

    generateReqInput(): ITCIApplicationsMonitoringRequest {
        return {
            request_type: TCI_APP_MONITORING_REQUEST_TYPE.APP_RESOURCE_CPU
        } as ITCIApplicationsMonitoringRequest;
    }

}
